export const environment: Environment = {
  name: 'develop',
  production: false,
  api: 'https://business-api-dev.roov.app',
  admin: 'https://admin-dev.roov.app',
  ccOrg: 'org_Iapp0kgb2Ku2t0gB',
  authConfig: {
    domain: 'auth-dev.roov.app',
    clientId: '6I8CnygvcKm81SjcNFiQo2EoXqWH02rB',
  },
};
